import { Platform } from '@interfaces/platform'
import ajax from '@services/client'

export const fetchProductDesc = async (params: {
  id: string
  platform: Platform
  sku?: string
}) => {
  if (params.platform === Platform.JD) {
    return ajax
      .get(`/products/${params.id}/details`, {
        params: { sku_id: params.sku },
      })
      .then(({ data }) => ({ desc: data.data?.desc, properties: data.data?.properties ?? [] }))
  }
  return ajax
    .get(`/products/${params.id}/description`, {
      params: { provider: 'taobao' },
    })
    .then(({ data }) => ({ desc: data?.data?.description }))
}

export const formatProducts = (products: any[]) =>
  products.map(p => ({
    ...p,
    skuId: p.jdProductId,
    platform: p.shopType,
    unavailable: p.unavailable,
    ...(p.sellerId &&
      !p.seller && {
      seller: {
        id: p.sellerId,
      },
    }),
  }))



export const fetchProducts = (params) => {
  const url = params.image ? '/products/image_search' : '/products'
  return ajax.get(url, {
    params: params
  }).then(({ data }) => ({ ...data, products: formatProducts(data.products) }))

}
